import { render, staticRenderFns } from "./DesignComponentsPagination.vue?vue&type=template&id=e4f6af7a"
import script from "./DesignComponentsPagination.vue?vue&type=script&lang=js"
export * from "./DesignComponentsPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsPagination.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports